module.exports = __webpack_public_path__ + "static/media/MHRP29N0013.3a271d90.svg";